import type { ReactNode } from 'react';
import { Suspense } from 'react';

export interface IconSuspenseProps {
  size: number | string | undefined;
  children: ReactNode;
}

export function IconSuspenseLoadingState(props: IconSuspenseProps) {
  return (
    <div
      style={{
        height: props.size,
        width: props.size,
        backgroundColor: 'transparent',
      }}
    />
  );
}

export function IconSuspense(props: IconSuspenseProps) {
  return <Suspense fallback={<IconSuspenseLoadingState {...props} />}>{props.children}</Suspense>;
}
